module.exports = __webpack_public_path__ + "assets/add-voting_icon.5e624954.svg";